import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles.scss';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-table/react-table.css';

ReactDOM.render(<App />, document.getElementById('root'));
